import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type { AnimalHealthLog } from "@project/types/vrindavan-gaushala";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/animal-health-logs`;
const SILENT: RequestConfig = { showNotification: false };

class AnimalHealthLogService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<AnimalHealthLog>> => {
    return fetchListPage<AnimalHealthLog>(`${BASE}/`, query);
  };

  get = async (id: number): Promise<AnimalHealthLog | undefined> => {
    const data = await get<ApiItemResponse<AnimalHealthLog> | AnimalHealthLog>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  create = async (
    payload: Record<string, unknown>
  ): Promise<AnimalHealthLog | undefined> => {
    const data = await post<
      ApiItemResponse<AnimalHealthLog> | AnimalHealthLog,
      Record<string, unknown>
    >(`${BASE}/`, payload, SILENT);
    return unwrapItem(data);
  };

  update = async (
    id: number,
    payload: Record<string, unknown>
  ): Promise<AnimalHealthLog | undefined> => {
    const data = await patch<
      ApiItemResponse<AnimalHealthLog> | AnimalHealthLog,
      Record<string, unknown>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const animalHealthLogService = new AnimalHealthLogService();
